const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const inputConfig = require('../../../input/client/js/config');
const prototype = require('./prototype');

module.exports = function CheckboxClient(selector = '[data-component="Checkbox"]', configuration = {}) {
    if (elementExist(selector)) {
        // Extend the proto input base with specific methods
        const instance = Object.create(prototype);

        // Config
        instance.config = { ...inputConfig, ...configuration };

        // Element reference
        instance.element = document.querySelector(selector);

        // Id reference
        instance.id = instance.element.dataset.id || randomId('checkbox');

        // Init error handler
        instance.error = false;

        // Value reference
        instance.value = instance.getInput().value;

        // Auto init
        if (instance.config.init) instance.init();

        return instance;
    }
};
